// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","icon":"_21B0v","closeCircle":"_2LTDb","closeIcon":"_1XHYG"};